import React, { useState } from 'react'
import { Space, Table, Modal, Button, Tag, Typography, Tooltip, ConfigProvider, Image, Input, Select } from 'antd';
import API_ROUTES from '../../../../api'
import axios from 'axios';
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react';
import moment from 'moment';
import { 
    DeleteOutlined, 
    CrownOutlined, 
    UserOutlined, 
    CheckCircleOutlined, 
    StopOutlined,
    ExclamationCircleOutlined,
    PhoneOutlined,
    ReloadOutlined,
    AuditOutlined,
    ClockCircleOutlined
} from '@ant-design/icons';

const { Text } = Typography;

export default function UserList(props) {

    const [currentPage, setCurrentPage] = useState(1)
    const [pageTotalCount, setPageTotalCount] = useState(0)
    const [currentPageSize, setCurrentPageSize] = useState(15)
    const [tableLoading, setTableLoadinng] = useState(false)
    const [pageData, setPageData] = useState([])
    const [filters, setFilters] = useState({ email: '', name: '', status: undefined })

    const navigate = useNavigate()

    const fetchData = (pageNum, pageSize, nextFilters = filters) => {
        setTableLoadinng(true)
        const nextPage = pageNum == null ? currentPage : pageNum;
        const nextPageSize = pageSize == null ? currentPageSize : pageSize;
        axios.get(API_ROUTES.api_user_list, {
            params: {
                current: nextPage,
                size: nextPageSize,
                email: nextFilters.email || undefined,
                name: nextFilters.name || undefined,
                status: nextFilters.status
            },
            headers: {
                "Authorization": localStorage.getItem('userInfo')
            }
        })
            .then(function (response) {
                if (response.data.code === 500) {
                    Modal.error({
                        content: response.data.msg
                    });
                } else {
                    setPageTotalCount(response.data.data.total);
                    setPageData(response.data.data.records);
                }
            })
            .catch(function (error) {
                navigate('/login')
                Modal.error({
                    content: error.response?.data?.msgDes || "Connection failed"
                });
            })
            .finally(function () {
                setTableLoadinng(false)
            })
    };


    useEffect(() => {
        fetchData();
    }, [props.refreshKey]);

    const openUserDetail = (record) => {
        localStorage.setItem('clickedUser', record.id);
        if (props.onOpenUser) {
            props.onOpenUser(record);
        } else if (props.onPageChange) {
            props.onPageChange('userdetail');
        }
    };

    const searchUsers = () => {
        // 筛选条件变化后从第一页重新查询，避免当前页码超出筛选后的结果页数
        setCurrentPage(1);
        fetchData(1, currentPageSize);
    };

    const resetFilters = () => {
        const emptyFilters = { email: '', name: '', status: undefined };
        setFilters(emptyFilters);
        setCurrentPage(1);
        fetchData(1, currentPageSize, emptyFilters);
    };


    const columns = [
        {
            title: 'User Role',
            dataIndex: 'manage',
            key: 'manage',
            width: '130px',
            render: (manage) => (
                manage === 1 ? 
                <Tag icon={<CrownOutlined />} color="gold" style={{ padding: '2px 8px', borderRadius: '4px' }}>Admin</Tag> : 
                <Tag icon={<UserOutlined />} color="blue" style={{ padding: '2px 8px', borderRadius: '4px' }}>User</Tag>
            )
        },
        {
            title: 'Email Address',
            dataIndex: 'email',
            key: 'email',
            ellipsis: true,
            width: '200px',
            render: (text, record) => (
                <Typography.Link 
                    strong 
                    style={{ color: '#055878' }}
                    onClick={() => openUserDetail(record)}
                >
                    {text}
                </Typography.Link>
            )
        },
        {
            title: 'Full Name',
            dataIndex: 'name',
            key: 'name',
            ellipsis: true,
            width: '120px'
        },
        {
            title: 'Organization',
            dataIndex: 'org',
            key: 'org',
            ellipsis: true,
            width: '180px',
            render: (text) => <Text type="secondary">{text || '-'}</Text>
        },
        {
            title: 'Proof Docs',
            dataIndex: 'studentCertificate',
            key: 'studentCertificate',
            width: '180px',
            render: (text) => {
                if (!text) return <Text type="disabled" style={{ fontSize: '12px' }}>No files</Text>;
                const urls = text.split(';');
                return (
                    <Image.PreviewGroup>
                        <Space size={4} wrap>
                            {urls.map((url, index) => (
                                <Image
                                    key={index}
                                    width={32}
                                    height={32}
                                    src={url}
                                    fallback="https://via.placeholder.com/32?text=Error"
                                    style={{ 
                                        objectFit: 'cover', 
                                        borderRadius: '4px', 
                                        border: '1px solid #f0f0f0',
                                        cursor: 'pointer'
                                    }}
                                />
                            ))}
                        </Space>
                    </Image.PreviewGroup>
                );
            }
        },
        {
            title: 'Contact',
            dataIndex: 'mobile',
            key: 'mobile',
            width: '140px',
            render: (text) => text ? <Space><PhoneOutlined style={{ color: '#8c8c8c' }} /><Text style={{ fontSize: '13px' }}>{text}</Text></Space> : '-'
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: '160px',
            render: (text, record) => {
                const statusConfig = {
                    0: { color: 'default', icon: <StopOutlined />, label: 'Disabled' },
                    1: { color: 'success', icon: <CheckCircleOutlined />, label: 'Enabled' },
                    2: { color: 'warning', icon: <ClockCircleOutlined />, label: 'Pending review' },
                }[text] || { color: 'default', icon: <StopOutlined />, label: 'Unknown' };
                return (
                    <Tag icon={statusConfig.icon} color={statusConfig.color} bordered={false}>
                        {statusConfig.label}
                    </Tag>
                )
            }
        },
        {
            title: 'Update Time',
            dataIndex: 'updateTime',
            render: (text) => text ? <Text type="secondary" style={{ fontSize: '12px' }}>{moment(text).format('YYYY-MM-DD')}</Text> : '-',
            key: 'updateTime',
            width: '110px'
        },
        {
            title: 'Actions',
            key: 'actions',
            fixed: 'right',
            width: '130px',
            align: 'center',
            render: (text, record) => (
                <Space size={4}>
                    <Tooltip title={record.status === 2 ? "Review pending account" : "View detail"}>
                        <Button
                            type={record.status === 2 ? 'primary' : 'text'}
                            size="small"
                            icon={<AuditOutlined />}
                            onClick={() => openUserDetail(record)}
                        />
                    </Tooltip>
                    <Tooltip title="Delete User">
                        <Button
                            type="text"
                            danger
                            size="small"
                            icon={<DeleteOutlined />}
                            disabled={record.manage === 1}
                            onClick={() => {
                                Modal.confirm({
                                    title: 'Are you sure you want to delete this user?',
                                    icon: <ExclamationCircleOutlined />,
                                    content: `This will permanently remove ${record.email} from the system.`,
                                    okText: 'Yes, Delete',
                                    okType: 'danger',
                                    cancelText: 'Cancel',
                                    onOk: () => {
                                        setTableLoadinng(true)
                                        axios.post(API_ROUTES.api_manage_update, {
                                            id: record.id,
                                            delete: 1
                                        }, {
                                            headers: { "Authorization": localStorage.getItem('userInfo') }
                                        })
                                            .then(function (response) {
                                                if (response.data.code === 500) {
                                                    Modal.error({ content: response.data.msg });
                                                } else {
                                                    Modal.success({ content: "User deleted successfully" });
                                                    fetchData();
                                                }
                                            })
                                            .catch(function (error) {
                                                Modal.error({ content: error.response?.data?.msgDes || "Delete failed" });
                                            })
                                            .finally(function () {
                                                setTableLoadinng(false)
                                            })
                                    }
                                });
                            }}
                        />
                    </Tooltip>
                </Space>
            )
        }
    ];

    return (
        <div style={{ background: 'white' }}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 12,
                marginBottom: '16px',
                flexWrap: 'wrap'
            }}>
                <Space size={12} wrap>
                    <Input
                        allowClear
                        placeholder="Search email"
                        value={filters.email}
                        onChange={(event) => setFilters((prev) => ({ ...prev, email: event.target.value }))}
                        onPressEnter={searchUsers}
                        style={{ width: 220 }}
                    />
                    <Input
                        allowClear
                        placeholder="Search name"
                        value={filters.name}
                        onChange={(event) => setFilters((prev) => ({ ...prev, name: event.target.value }))}
                        onPressEnter={searchUsers}
                        style={{ width: 180 }}
                    />
                    <Select
                        allowClear
                        placeholder="Account status"
                        value={filters.status}
                        onChange={(value) => setFilters((prev) => ({ ...prev, status: value }))}
                        style={{ width: 180 }}
                        options={[
                            { value: 0, label: 'Disabled' },
                            { value: 1, label: 'Enabled' },
                            { value: 2, label: 'Pending review' },
                        ]}
                    />
                    <Button type="primary" onClick={searchUsers}>
                        Search
                    </Button>
                    <Button onClick={resetFilters}>
                        Reset
                    </Button>
                </Space>
                <Button
                    icon={<ReloadOutlined />}
                    loading={tableLoading}
                    onClick={() => fetchData(currentPage, currentPageSize)}
                >
                    Refresh
                </Button>
            </div>
            <ConfigProvider theme={{
                components: {
                    Table: {
                        headerBg: '#f0f4f8',
                        headerColor: '#055878',
                        headerBorderRadius: 8,
                        rowHoverBg: '#f8fbff'
                    }
                }
            }}>
                <Table
                    columns={columns}
                    dataSource={pageData}
                    rowKey="id"
                    loading={tableLoading}
                    pagination={{
                        showQuickJumper: true,
                        showSizeChanger: true,
                        defaultPageSize: 15,
                        current: currentPage,
                        total: pageTotalCount,
                        onChange: (page, pageSize) => {
                            setCurrentPage(page);
                            setCurrentPageSize(pageSize);
                            fetchData(page, pageSize);
                        },
                        style: { marginTop: '24px' }
                    }}
                    scroll={{ x: 1000 }}
                    size="middle"
                    style={{ borderRadius: '8px' }}
                />
            </ConfigProvider>
        </div>
    )
}
